import { WorkpackService } from 'client/services';

const action = async ({ request }) => {
    if (request.method === 'DELETE') {
        const { workpackRequestIds } = Object.fromEntries(await request.formData());
        if (workpackRequestIds) {
            await WorkpackService.deleteWorkpackRequests(workpackRequestIds);
            return { deleted: true };
        }
    }
    return {};
};

export default action;
